import { db } from '.';

const groupsRef = db.collection('groups');

async function addDeepLinkSnapFromDB({ groupId, conceptId, ...docData }) {
  const newGroupRef = groupsRef
    .doc(groupId)
    .collection('conceptDeepLinks')
    .doc(conceptId);
  await newGroupRef.set(docData);
  return newGroupRef;
}

async function getDeepLinkSnapFromDB({ groupId, conceptId }) {
  const deepLinkSnap = await groupsRef
    .doc(groupId)
    .collection('conceptDeepLinks')
    .doc(conceptId)
    .get();
  return deepLinkSnap.exists ? deepLinkSnap.data() : null;
}

export default {
  add: addDeepLinkSnapFromDB,
  get: getDeepLinkSnapFromDB
};
